module.exports = __webpack_public_path__ + "static/media/excetute_phy.f0b2b6a6.png";